import ErrorService from "vamos/cockpit/base/services/type/ErrorService";
import BusyIndicator from "sap/ui/core/BusyIndicator";
import Config from "vamos/cockpit/config/Config";
import BaseController from "vamos/cockpit/base/controller/type/BaseController";

export default class FileService {

    private controller: BaseController;

    public constructor(controller: BaseController) {
        this.controller = controller;
    }

    public async downloadFile(
        p_fileEndpoint: string,
        p_formData: object,
        p_filename: string,
        p_extension: string,
        p_includeDate: boolean,
        p_method = "POST",
        p_successFunction: (response: Response) => void = null,
        p_errorFunction = (response: Response) => ErrorService.getInstance().showAPIServiceError(response),
    ) {
        const config = new Config();
        const oViewModel = this.controller?.getModel("view");
        const bNoBusyIndicator = oViewModel?.getProperty("/noBusyIndicator") as boolean;
        try {
            if (!bNoBusyIndicator) {
                BusyIndicator.show();
            }
            const requestObject: RequestInit = {
                method: p_method,
                headers: {
                    "Content-Type": "application/json",
                },
            };

            if (p_formData) {
                requestObject.body = JSON.stringify(p_formData);
            }

            const response = await fetch(config.getRestUrl(p_fileEndpoint, false), requestObject);
            if (response.status !== 200) {
                p_errorFunction(response);
            }
            const blob = await response.blob();
            this.handleFileResponse(blob, p_filename, p_extension, p_includeDate);

            if (p_successFunction) {
                p_successFunction(response);
            }
        } catch (e) {
            console.error(e);
        } finally {
            BusyIndicator.hide();
        }
    };

    public async downloadPDFFile(
        p_fileEndpoint: string,
        p_filename: string,
        p_extension: string,
        p_includeDate: boolean,
        p_successFunction: (response: Response) => void = null,
        p_errorFunction = (response: Response) => ErrorService.getInstance().showAPIServiceError(response),
    ) {
        await this.downloadFile(p_fileEndpoint, null, p_filename, p_extension, p_includeDate, "GET", p_successFunction, p_errorFunction);
    };


    public async downloadExcelFile(sExcelGuid: string, sFileName: string) {
        if (!sExcelGuid) {
            throw new Error("no excelguid");
        }
        await this.downloadFile(`/excel/download/${sExcelGuid}`, null, sFileName, "xlsx", true, "GET");
    }


    private handleFileResponse(oBlob: Blob, sFilename: string, sExtension: string, bIncludeDate: boolean) {
        const url = window.URL.createObjectURL(oBlob);
        const a = document.createElement("a");
        a.href = url;
        const sDate = new Date().toISOString().split("T")[0];
        if (bIncludeDate) {
            a.download = sFilename + "_" + sDate + "." + sExtension;
        } else {
            a.download = sFilename + "." + sExtension;
        }
        document.body.appendChild(a);
        a.click();
        a.remove();
    };

}
